import { lazy, Suspense } from 'react';
import { Routes, Route, Outlet } from 'react-router-dom';
import Nav from './components/Nav';
import Footer from './components/Footer';
import { Modals } from './components/Modal';
import Home from './routes/Home';
import How from './routes/How';
import Elaria from './routes/Elaria';
import Platforms from './routes/Platforms';
import Trust from './routes/Trust';
import Attorneys from './routes/Attorneys';
import VerifyEmail from './routes/VerifyEmail';
import MeetYourLawyer from './routes/MeetYourLawyer';
import NotFound from './routes/NotFound';

// Client portal is code-split: none of it (incl. the docket) ships in the
// public marketing bundle, and it renders its own chrome, not Nav/Footer.
const Portal = lazy(() => import('./routes/portal/Portal'));

function MarketingLayout() {
  return (
    <>
      <Nav />
      <main>
        <Outlet />
      </main>
      <Footer />
      <Modals />
    </>
  );
}

export default function App() {
  return (
    <Routes>
      <Route element={<MarketingLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/how" element={<How />} />
        <Route path="/elaria" element={<Elaria />} />
        <Route path="/platforms" element={<Platforms />} />
        <Route path="/trust" element={<Trust />} />
        <Route path="/attorneys" element={<Attorneys />} />
        {/* Deep-link target from the verification email — intentionally not in Nav. */}
        <Route path="/verify-email" element={<VerifyEmail />} />
        {/* Public pre-pay "meet your lawyer" card, keyed by magic token. Zero-auth,
            deep-link only, tenant-branded — never in Nav (P1-1). */}
        <Route path="/meet/:token" element={<MeetYourLawyer />} />
        <Route path="*" element={<NotFound />} />
      </Route>
      <Route
        path="/portal/*"
        element={
          <Suspense fallback={null}>
            <Portal />
          </Suspense>
        }
      />
    </Routes>
  );
}
